/* ── Color Palette & Design Tokens ── */
export const theme = {
  bg: "#0A0A0F",
  bgCard: "#111118",
  bgGlass: "rgba(17,17,24,0.85)",
  gold: "#C8A456",
  goldLight: "#E8D5A0",
  goldDark: "#9A7B33",
  cream: "#F5F0E8",
  text: "#E8E4DC",
  textMuted: "#9A9690",
  accent: "#1A1A25",
  border: "rgba(200,164,86,0.15)",
  borderHover: "rgba(200,164,86,0.4)",
};

export const fontStack = `'Cormorant Garamond', 'Georgia', serif`;
export const bodyFont = `'DM Sans', 'Helvetica Neue', sans-serif`;
